import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { CoreHelperService } from 'src/app/providers/core-helper/core-helper.service';
import { Modules } from '../../providers/core-role-access-service';
import { AuthSessionService } from 'src/app/providers/auth-session/auth-session.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard {
  constructor(
    private authSession: AuthSessionService,
    private router: Router,
    private coreHelperService: CoreHelperService,
  ) { }

  async canActivate(route: ActivatedRouteSnapshot) {
    var userData = this.coreHelperService.getLoggedInUserDetail();
    if (this.coreHelperService.isNullOrUndefined(userData)) {
      // No cached profile (new tab, cleared storage): ask the API whether the session cookie is still valid.
      const session = await this.authSession.restoreSession();
      if (!session.ok) {
        return this.router.createUrlTree(['']);
      }
    }
    if (this.coreHelperService.checkIsAgreedAgreement() == 0) {
      this.router.createUrlTree(['/non-auth/user-agreement']);
      return true;
    }
    // code update as per new changes in permission
    return true;
  }

  async logout() {
    await this.authSession.logout();
  }

  public get module() {
    return Modules;
  }
}
